import { useSyncExternalStore } from "react";
import { createPortal } from "react-dom";
import { AlertCircle, CheckCircle2, Info, X } from "lucide-react";
import {
  dismissMailToast,
  getMailToasts,
  subscribeMailToasts,
  type MailToastEntry,
} from "@/lib/ui/mailToast";
import { cn } from "@/lib/cn";

function ToastIcon({ variant }: { variant: MailToastEntry["variant"] }) {
  if (variant === "success") {
    return <CheckCircle2 className="h-4 w-4 shrink-0 text-[var(--mail-accent)]" aria-hidden />;
  }
  if (variant === "error") {
    return <AlertCircle className="h-4 w-4 shrink-0 text-[var(--mail-danger-text)]" aria-hidden />;
  }
  return <Info className="h-4 w-4 shrink-0 text-[var(--mail-muted)]" aria-hidden />;
}

export function MailToastHost() {
  const toasts = useSyncExternalStore(subscribeMailToasts, getMailToasts, getMailToasts);

  if (toasts.length === 0) return null;

  return createPortal(
    <div className="mail-toast-stack" aria-live="polite" aria-relevant="additions">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          role="status"
          className={cn("mail-toast", toast.variant === "error" && "mail-toast-error")}
        >
          <ToastIcon variant={toast.variant} />
          <p className="mail-toast-message">{toast.message}</p>
          <button
            type="button"
            className="mail-toast-dismiss"
            aria-label="Fermer"
            onClick={() => dismissMailToast(toast.id)}
          >
            <X className="h-3.5 w-3.5" aria-hidden />
          </button>
        </div>
      ))}
    </div>,
    document.body
  );
}
